import * as React from 'react';
import styled from 'styled-components';
import { useState } from 'react';
import { format, addDays, isSameDay, startOfWeek, startOfMonth, endOfMonth, endOfWeek, isBefore } from 'date-fns';
import { dateFnsLocale } from '../utils/dateHelper';

import CalendarDateContainerView from './views/CalendarDateContainerView';
import CalendarDateView from './views/CalendarDateView';
import CalendarDaysView from './views/CalendarDaysView';
import CalendarHeaderView from './views/CalendarHeaderView';

const CalendarView = styled.div`
  flex: 1;
  margin: 4px 8px;
`;

interface IProps {
  selectedDateList: Date[];
  currentMonth: Date;
  handleDateClick: (event: React.MouseEvent) => void;
  handlePrevMonthClick?: () => void;
  handleNextMonthClick?: () => void;
}

const Calendar: React.FC<IProps> = (props) => {
  const { selectedDateList, currentMonth, handleDateClick,
    handlePrevMonthClick, handleNextMonthClick } = props;

  const days = (): string[] => {
    const days = [];
    const startDate = startOfWeek(currentMonth);
    for (let i = 0; i < 7; i++) { days.push(format(addDays(startDate, i), 'eeeeee', { locale: dateFnsLocale() })); }
    return days;
  }

  const renderCells = () => {
    const yesterday: Date           = addDays(new Date(), -1);
    const startDateOfMonth: Date    = startOfMonth(currentMonth);
    const endDateOfMonth: Date      = endOfMonth(currentMonth);
    const startDateOfCalendar: Date = startOfWeek(startDateOfMonth);
    const endDateOfCalendar: Date   = endOfWeek(endDateOfMonth);
    const days: JSX.Element[] = [];

    let day: Date = startDateOfCalendar;
    while (day <= endDateOfCalendar) {
      const classNameList: string[] = [];
      if (day < startDateOfMonth || day > endDateOfMonth) { classNameList.push('hidden'); }
      if (isBefore(day, yesterday)) { classNameList.push('disabled'); }
      if (isSameDay(selectedDateList[0], day)) { classNameList.push('start'); }
      if (isSameDay(selectedDateList[selectedDateList.length - 1], day)) { classNameList.push('end'); }
      if (selectedDateList.some(date => isSameDay(date, day))) { classNameList.push('between'); }

      const clickDisabled: boolean = ['hidden', 'disabled'].filter(name => classNameList.indexOf(name) !== -1).length > 0;

      days.push(
        <CalendarDateView
          key={`date-${day}`}
          data-date={format(day, 'yyyy-MM-dd')}
          onClick={clickDisabled ? null : handleDateClick}
          className={classNameList.join(' ')}
        >
          <div className="label">{format(day, 'd')}</div>
        </CalendarDateView>
      );
      day = addDays(day, 1);
    }
    return (
      <CalendarDateContainerView>
        {days}
      </CalendarDateContainerView>
    );
  }

  return (
    <CalendarView>
      <CalendarHeaderView>
        {handlePrevMonthClick ? <div className="icon left" onClick={handlePrevMonthClick} /> : <div className="icon-empty" />}
        <div className="month">{format(currentMonth, 'MMMM yyyy', { locale: dateFnsLocale() })}</div>
        {handleNextMonthClick ? <div className="icon right" onClick={handleNextMonthClick} /> : <div className="icon-empty" />}
      </CalendarHeaderView>
      <CalendarDaysView>
        {days().map(day => <div key={`day-${day}`}>{day}</div>)}
      </CalendarDaysView>
      <div>{renderCells()}</div>
    </CalendarView>
  );
};

export default Calendar;
